import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'

export default function useDataTransform(props, data) {
  let email = useDataValue({
    viewPath: props.viewPath,
    context: 'email',
  })
  return useMemo(() => {
    if (!data) return data

    return [
      ...data,
      ...(email.preference === false
        ? [
            {
              id: 'SET_PREFERRED',
              text: 'Set Preferred',
            },
          ]
        : []),
    ]
  }, [data, email])
}
